<template>
  <llp-page
    id="datatable-page"
    :menuOptions="menuOptions"
    :pageName="pageName"
    :userName="userName"
  >
    <template v-slot:body>
      <div class="rental-row">
        <div class="card m-2 m-lg-3">
          <div class="card-body">
            <!-- Top Section -->
            <div class="d-flex justify-content-between align-items-center">
              <div>
                <h6>URN Number</h6>
                <div class="d-flex align-items-center">
                  <h5 class="me-2 order-id">{{ this.reports.urn }}</h5>
                  <i
                    class="fas fa-copy copy-icon"
                    @click="copyText(`${this.reports.urn}`)"
                  />
                </div>
              </div>
              <div class="text-end">
              

                <h6>Status</h6>
                  <h5 :class="['paymentStatus', paymentStatusClass]">
                  {{ reports.payment_status }}
                </h5>
              </div>
            </div>
            <hr />
            <!-- Customer Details -->
            <h5 class="fw-bold">Customer Details</h5>
            <div class="row mt-3 gy-4 customer-details">
              <div class="col-12 col-md-6 col-lg-3">
                <h6>Name:</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <h5 class="me-2 mb-0">{{ this.reports.name }}</h5>
                  <i
                    class="fas fa-copy copy-icon"
                    @click="copyText(`${this.reports.name}`)"
                  ></i>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <h6>Email:</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <h5 class="me-2 mb-0">{{ this.reports.email }}</h5>
                  <i
                    class="fas fa-copy copy-icon"
                    @click="copyText(`${this.reports.email}`)"
                  ></i>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <h6>Phone No:</h6>
                <div class="d-flex align-items-center flex-wrap">
                  <h5 class="me-2 mb-0">{{ this.reports.mobile	 }}</h5>
                  <i
                    class="fas fa-copy copy-icon"
                    @click="copyText(`${this.reports.mobile	}`)"
                  ></i>
                </div>
              </div>
              <div class="col-12 col-md-6 col-lg-3">
                <h6>Customer Ref ID:</h6>
                <div class="d-flex align-items-center flex-wrap mt-2">
                  <h5 class="me-2 mb-0">{{ this.reports.urn || 'N/A' }}</h5>
                  <i
                    class="fas fa-copy copy-icon"
                    @click="copyText(`${this.reports.urn}`)"
                  ></i>
                </div>
              </div>
            </div>
            <hr />
            <h5 class="fw-bold">Services Details</h5>
            <div class="mt-4">
              <div class="row">
                <div class="col-md-4">
                  <p>
                    <strong>Service Name</strong><br />{{
                      this.reports.services?.name || 'N/A'
                    }}
                  </p>
                </div>
                <div class="col-md-4">
                  <p><strong>Amount</strong><br />{{ this.reports.amount }}</p>
                </div>
                <div class="col-md-4">
                  <p>
                    <strong>Payment For</strong><br />{{
                      this.reports.payment_for || 'N/A'
                    }}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <!-- Timeline -->
            <h5 class="fw-bold">Timeline</h5>
            <div class="mt-4">
              <p><strong>{{formatDate(this.reports.created_at)}}</strong></p>
              <!-- <p class="text-success"><strong>{{this.reports.status}}</strong></p> -->
              <div class="row">
                <div class="col-md-4">
                  <p>
                    <strong>Bank Reference No</strong
                    ><br />{{this.reports.bank_reference_no || 'N/A'}}
                  </p>
                  <p><strong>Transaction Status</strong><br />{{this.reports.payment_status	}}</p>
                </div>
                <div class="col-md-4">
                  <p>
                    <strong>Error Description</strong><br />{{this.reports.error_description || 'N/A'}}
                  </p>
                  <p><strong>Error Source</strong><br />{{this.reports.error_source || 'N/A'}}</p>
                </div>
                <div class="col-md-4">
                  <p><strong>Transaction Message</strong><br />{{this.reports.transaction_message || 'N/A'}}</p>
                  <p>
                    <strong>Error Code</strong><br />{{this.reports.error_code || 'N/A' }}
                  </p>
                </div>
              </div>
            </div>
            <hr />
            <!-- Payment Created -->
            <!-- <div class="mt-4">
              <p><strong>{{formatDate(this.reports.created_at)}}</strong></p>
              <p class="text-success"><strong>Payment Created</strong></p>

              <div class="row">
                <div class="col-md-4">

                  <p><strong>Bank</strong><br />{{this.reports.bank  || 'N/A'}}</p>
                  <p><strong>Card Country</strong><br />{{this.reports.currency  || 'N/A'}}</p>
                </div>
                <div class="col-md-4">
                  <p><strong>Card Type</strong><br />{{this.reports.card_type  || 'N/A'}}</p>
                  <p><strong>PG</strong><br />{{this.reports.payment_gateway  || 'N/A'}}</p>
                </div>
                <div class="col-md-4">
                  <p><strong>Payment Mode</strong><br />{{this.reports.payment_mode  || 'N/A'}}</p>
                  <p><strong>Card Number</strong><br />{{this.reports.card_number  || 'N/A'}}</p>
                </div>
              </div>
            </div> -->
           <div class="mt-4" v-if="Object.keys(filteredPaymentMethod).length">

  <h5 class="fw-bold">Payment Details</h5>
      <p class="text-success"><strong>Payment Created</strong></p>
  <p><strong>{{formatDate(this.reports.created_at)}}</strong></p>

  <div class="row">
    <div
      class="col-md-4 mb-3"
      v-for="(value, key) in filteredPaymentMethod"
      :key="key"
    >
     
      <p>
        <strong>{{ formatKey(key) }}</strong><br />
        {{ formatValue(value) || 'N/A' }}
      </p>
    </div>
  </div>
  <div class="row">
    <p><strong>Paid Amount</strong></p>
    <h5>₹{{ this.reports.amount }}</h5>
  </div>
</div>
              <hr />
              <!-- pay out details -->
            <h5 class="fw-bold">Pay Out Details</h5>

               <div class="mt-4" >
              <p><strong>{{formatDate(this.reports.payment_date || 'N/A')}}</strong></p>
              <p class="text-success"><strong>Payment Date</strong></p>

              <div class="row">
                <div class="col-md-4">
                  <p><strong>Transfer Id</strong><br />{{this.reports.transfer_id || 'N/A'}}</p>
                  <p><strong>Transfer Status</strong><br />{{this.reports.transfer_status	 || 'N/A'}}</p>
                  <p><strong>Fund Source Id</strong><br />{{this.reports.fundsource_id|| 'N/A'}}</p>
               
                </div>
                <div class="col-md-4">
                  <p><strong>Transfer Status Code</strong><br />{{this.reports.transfer_status_code	|| 'N/A'	 || 'N/A'}}</p>
                  <p><strong>Transfer Mode</strong><br />{{this.reports.transfer_mode	|| 'N/A'}}</p>
                </div>
                <div class="col-md-4">
                  <p><strong>Transfer Status Description	</strong><br />{{this.reports.transfer_status_description		|| 'N/A'	 || 'N/A'}}</p>

                </div>
              </div>
            </div>
             
            <!-- Refund  details -->
                <div class="mt-4" v-if="this.reports.refund_id">
                  <hr />
            <h5 class="fw-bold">Refund Details</h5>

              <p><strong>{{this.reports.refund_created_at || 'N/A'	}}</strong></p>
              <p class="text-success"><strong>Refund Created at</strong></p>

              <div class="row">
                <div class="col-md-4">
                  <p><strong>Refund Id</strong><br />{{this.reports.refund_id	|| 'N/A'}}</p>
                  <p><strong>Refund Amount</strong><br />{{this.reports.refund_amount	|| 'N/A'}}</p>
                  <p><strong>Refund Status</strong><br />{{this.reports.refund_status	 || 'N/A'}}</p>
                </div>
                <div class="col-md-4">
                  <p><strong>Refund Type</strong><br />{{this.reports.refund_type	|| 'N/A'}}</p>
                  <p><strong>Refund Status Description	</strong><br />{{this.reports.refund_status_description	|| 'N/A'}}</p>
                  <p><strong>Status</strong><br />{{this.reports.status	 || 'N/A'}}</p>

                </div>
                <div class="col-md-4">
                  <p><strong>Refund Status Description</strong><br />{{this.reports.refund_status_description	  || 'N/A'}}</p>
                </div>
              </div>
            </div>
            <div class="col d-flex justify-content-end">
              <llp-button
                :load-spinner="showaddUserSpinner"
                classNames="btn-secondary new-btn"
                type="button"
                @click="BackToSupport()"
              >
                Back To Reports
              </llp-button>
            </div>
          </div>
        </div>
      </div>
    </template>
  </llp-page>
</template>

<script>
import NetworkService from "@/services/network.service";
export default {
  name: "ViewReports",

  data() {
    return {
      reportId: this.$route.params.id,
      reports: [],
    };
  },
  mounted() {
    this.fetchingReportData();
  },

 computed: {
  paymentStatusClass() {
    const status = (this.reports.payment_status || '').toUpperCase();
    if (status === 'PAID') {
      return 'text-success'; 
    } else if (status === 'PENDING') {
      return 'text-warning'; 
    } else if (status === 'FAILED') {
      return 'text-danger'; 
    } else {
      return 'text-secondary'; 
    }
  },
  filteredPaymentMethod() {
    if (!this.reports.payment_method || typeof this.reports.payment_method !== 'object') {
      return {};
    }

    const excludedKeys = ['channel','instrument_id','card_network_reference_id','card_sub_type','upi_payer_ifsc','upi_payer_account_number','upi_instrument_number'];
    return Object.entries(this.reports.payment_method)
      .filter(([key]) => !excludedKeys.includes(key))
      .reduce((acc, [key, value]) => {
        acc[key] = value;
        return acc;
      }, {});
  },
},

  methods: {
    copyText(text) {
      navigator.clipboard.writeText(text).then(() => {
        alert("Copied to clipboard: " + text);
      });
    },
    formatKey(key) {
    return key
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()); 
  },

  formatValue(value) {
    if (typeof value !== "string") return value;
    return value
      .replace(/_/g, " ")
      .replace(/\b\w/g, (char) => char.toUpperCase()); 
  },
formatDate(dateString) {
  if (!dateString) return "N/A";

  // If ISO format (has 'T' or space)
  if (dateString.includes("T") || dateString.includes(" ")) {
    const isoString = dateString.replace(" ", "T");
    const date = new Date(isoString);
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
  }

  // If DD-MM-YYYY format
  const parts = dateString.split("-");
  if (parts.length === 3) {
    const [day, month, year] = parts;
    const date = new Date(`${year}-${month}-${day}`); 
    if (!isNaN(date.getTime())) {
      return date.toLocaleDateString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    }
  }

  return "N/A";
},
    // async fetchingReportData() {
    //   try {
    //     const reportData = await NetworkService.get(
    //       `/transaction-list-by-id/${this.reportId}`
    //     );
    //     this.reports = reportData.data;
    //   } catch (error) {
    //     this.$refs.toast.show("Unable to fetching the report.", "error");
    //   }
    // },
    async fetchingReportData() {
  try {
    const reportData = await NetworkService.get(
      `/transaction-list-by-id/${this.reportId}`
    );
    const data = reportData.data;
    if (data.payment_method && typeof data.payment_method === "string") {
      try {
        data.payment_method = JSON.parse(data.payment_method);
      } catch (e) {
        data.payment_method = {};
      }
    }
    this.reports = data;
    console.log("this is reports",this.reports.payment_method);
    
  } catch (error) {
    this.$refs.toast.show("Unable to fetch the report.", "error");
  }
},
    BackToSupport() {
      this.$router.push("/user-reports");
    },
  },
};
</script>


